"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utm_1 = require("../../redux/utm");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var RouteChangeHandler = function () {
    var location = react_router_dom_1.useLocation();
    var dispatch = react_redux_1.useDispatch();
    react_1.useEffect(function () {
        var searchParams = new URLSearchParams(location.search);
        if (searchParams.has('utm_campaign') ||
            searchParams.has('utm_content') ||
            searchParams.has('utm_medium') ||
            searchParams.has('utm_source') ||
            searchParams.has('utm_term')) {
            dispatch(utm_1.setUtmState({
                /** Die genaue Bezeichnung der Kampagne oder Promotion für die Keyword-Analyse */
                utmCampaign: searchParams.get('utm_campaign') || '',
                /** Wird für die Unterscheidung zwischen ähnlichem Content in Anzeigen oder Links verwendet, die auf dieselbe URL verweisen. Für content-orientierte Anzeigen und A/B-Tests */
                utmContent: searchParams.get('utm_content') || '',
                /** Das Werbe- oder Marketingmedium oder die Art von geteiltem Content, z.B. ein Blog-Beitrag. */
                utmMedium: searchParams.get('utm_medium') || '',
                /** Das soziale Netzwerk, die Suchmaschine, der Newsletter-Name oder eine andere Quelle, die zu Traffic führt */
                utmSource: searchParams.get('utm_source') || '',
                /** Wird für das Tracking von bezahlten Keywords verwendet. */
                utmTerm: searchParams.get('utm_term') || ''
            }));
        }
    }, [dispatch, location]);
    return null;
};
exports.default = RouteChangeHandler;
//# sourceMappingURL=RouteChangeHandler.js.map